import React from 'react';
import Select from 'react-select';
import { Spinner } from 'react-bootstrap';
import { formService } from '../../_services/form.service';
import { useEffect, useState } from 'react';

export default function FormOption({ defaultValue, handleSelected, disabled = false, textDark = false }) {
  const [formOptions, setFormOptions] = useState([]);
  const [formSelected, setFormSelected] = useState("");

  useEffect(() => {
    setFormSelected(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    formService.getAllForms('Form')
      .then((forms) => {
        setFormOptions(
          forms.map((form) => {
            return { value: form.id, label: form.title };
          })
        )
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (formOptions.length === 0) {
    return <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  }

  const formOptionSelected = formOptions.find((form) => {
    return form.value === formSelected;
  });

  return (
    <Select
      placeholder='By Form'
      isClearable={true}
      options={formOptions}
      onChange={selected => {
        if (selected) {
          setFormSelected(selected.value)
          handleSelected(selected.value, selected.label);
        } else {
          setFormSelected('');
          handleSelected('', '');
        }
      }}
      isDisabled={disabled}
      styles={textDark && {
        singleValue: (styles) => {
          return {
            ...styles, color: 'black',
          };
        },
      }}
      value={formOptionSelected || ''}
    />
  )
}
